<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="关键词：" class="query-form-item">
                <el-input placeholder="请输入商品ASIN或商品标题" v-model="filter.keyword" clearable style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="add">导入评论地址</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @row-click="clickRowHandle"
            @expand-change="clickRowHandle1"
            :header-cell-style="{background:'black',color: '#fff','font-size':'12px'}"
            size="mini"
            class="table_content"
            border
            style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <inline :ref="'inline' + props.row.asin" :datasrow="props.row" @close-list="closeList"></inline>
                </template>
            </el-table-column>
            <el-table-column 
                label="商品图片"
                width="90"
                align="center">
                <template slot-scope="scope">
                    <el-popover v-if="scope.row.image_url != null" placement="right" title trigger="hover">
                        <div style="width:200px;height:200px;">
                            <img
                                style="width:100%;height:100%;"
                                :src="scope.row.image_url"
                                alt
                            />
                        </div>
                        <div style="width:70px;height:70px;" slot="reference">
                            <img
                                style="width:100%;height:100%;"
                                :src="scope.row.image_url"
                                alt
                            />
                        </div>
                    </el-popover>
                    <div v-if="scope.row.discontinued == 1" style="color: red;">商品已下架</div>
                </template>
            </el-table-column>
            <el-table-column
                width="140"
                align="center"
                label="商品ASIN">
                <template slot-scope="scope">
                    <div v-if="scope.row.asin != null" @click.stop="edirectToAsin(scope.row)" style="cursor: pointer;color: rgb(52, 73, 94);">
                        <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.parent_asin }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="250"
                label="商品标题">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.title }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="监控评价数量"
                width="134"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.review_count }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="已经掉评数量"
                width="134"
                align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.dropped_review_count }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :current-page="query.page"
            :page-size="query.limit"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total"
            style="float: right;margin-top: 20px; margin-bottom: 12px"
            background>
        </el-pagination>
        <add :visible="ctrl.addDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback" @error-dialog="errorDialog"></add>
        <error-page :visible="ctrl.errorVisible" :list="listData" @close-callback="closeCllback"></error-page>
    </div>
</template>

<script>
import * as api from "@/api/evaluation/evaluation";
import { link_us } from "@/utils/method";
import Inline from "./inline";
import Add from "./add";
import ErrorPage from "./errorPage";
export default {
    components: { Inline, Add, ErrorPage },
    data() {
        return {
            // 获取row的key值
            getRowKeys(row) {
                return row.asin;
            },
            expands: [],
            list: [],
            ctrl: {
                addDialogVisible: false,
                errorVisible: false
            },
            filter: {},
            query: {
                page: 1,
                limit: 20
            },
            formData: {},
            listData: [],
            loading: false
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            obj.filter = this.filter;
            this.loading = true;
            api.product_aggressive_page_list(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //点击展开
        clickRowHandle(row) {
            if (this.expands.includes(row.asin)) {
                this.expands = this.expands.filter(val => val !== row.asin);
            } else {
                this.expands.push(row.asin);
                let str = "inline" + row.asin;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        clickRowHandle1(row) {
            if (this.expands.includes(row.asin)) {
                this.expands = this.expands.filter(val => val !== row.asin);
            } else {
                this.expands.push(row.asin);
                let str = "inline" + row.asin;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        //同步删除数据
        closeList(data) {
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].asin == data.asin) {
                    if (this.list[i].review_count == 1) {
                        this.getList();
                    } else if (data.review_failure == 1) {
                        this.list[i].review_count =
                            Number(this.list[i].review_count) - 1;
                        this.list[i].dropped_review_count =
                            Number(this.list[i].dropped_review_count) - 1;
                    } else {
                        this.list[i].review_count =
                            Number(this.list[i].review_count) - 1;
                    }
                }
            }
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            let url =
                link_us(data.country_code) +
                "dp/" +
                data.parent_asin +
                "?th=1&psc=1";
            window.open(url, "_blank");
        },
        //复制链接
        copy(data) {
            let url = data.link;
            var oInput = document.createElement("input");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            oInput.className = "oInput";
            oInput.style.display = "none";
        },
        //筛选
        add() {
            this.ctrl.addDialogVisible = true;
            this.ctrl.dialogTitle = "添加评价监控";
        },
        //错误内容
        errorPageDialog() {
            this.ctrl.errorVisible = true;
        },
        //错误页面
        errorDialog(data) {
            let that = this;
            this.listData = data.data;
            setTimeout(function() {
                that.errorPageDialog();
            }, 10);
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.filter = {};
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addDialogVisible = false;
            this.ctrl.errorVisible = false;
            if (isshow) return;
            this.getList();
        }
    },
    created() {
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.table_content {
    height: calc(100vh - 260px);
    overflow: auto;
    border: 1px solid #ebeef5;
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
/deep/ .el-table::before {
    display: none;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer !important;
    background-color: #fff !important;
}
/deep/ .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}
.el-tooltip__popper {
    max-width: 300px !important;
}
.pen {
    cursor: pointer;
}
</style>
